export const formatPhoneNumber = (number = "") => {
  if (!number) return number;

  let phone = "1-";
  if (number.length > 0) phone += number.substring(0, 3);
  if (number.length > 3) phone += `-${number.substring(3, 6)}`;
  if (number.length > 6) phone += `-${number.substring(6, 10)}`;
  return phone;
};
